export default "__VITE_ASSET__BJu11XHY__"